import Breadcrumb from "../../../components/admin/layouts/Breadcrumb/Breadcrumb";
import Container from "../../../components/admin/layouts/Container/Container";
import Header, { HeaderLeft, HeaderRight } from "../../../components/admin/layouts/Header/Header";
import PageWrapper from "../../../components/admin/layouts/PageWrapper/PageWrapper";
import Subheader, {
  SubheaderLeft,
  SubheaderRight,
  SubheaderSeparator,
} from "../../../components/admin/layouts/Subheader/Subheader";
import CompanyImg from "../../../assets/png/company.png";
import DefaultHeaderRightCommon from "../../../templates/layouts/Headers/_common/DefaultHeaderRight.common";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "../../../components/ui/Button";
import Card, { CardBody, CardHeader, CardHeaderChild, CardTitle } from "../../../components/ui/Card";
import Label from "../../../components/ui/Label";
import Input from "../../../components/form/Input";
import { useFormik } from "formik";
import * as Yup from "yup";
import RichText from "../../../components/ui/RichText";
import classNames from "classnames";
import Icon from "../../../components/icon/Icon";
import themeConfig from "../../../config/theme.config";
import Badge from "../../../components/ui/Badge";
import { DefaultAssetID, Google_map_Key, vizybilityConfig } from "../../../api/url";
// import { useMsal } from "@azure/msal-react"; // Azure B2C - temporarily disabled
import { useEffect, useRef, useState } from "react";
import { postGetVizyBilityToken } from "../../../services/getVizyBilityToken";
import { cleanObjectKeys, formatDate, logoutFun } from "../../../utils/helper";
import { toast } from "react-toastify";
import GooglePlacesAutocomplete from "react-google-autocomplete";
import {
  addAsset,
  addAssetAdvertisements,
  addCategori,
  addLocation,
  checkUnitNumber,
  getAssetByID,
  getAssetMake,
  getAssetStatuses,
  getContactById,
  getExtraData,
  getExtraDataSchema,
  getLocations,
  saveExtra,
  savePicture,
  uploadBulkImg,
} from "../../../services/vizyBilityServices";
import { ApplicationId } from "../../../api/url";
import Select from "../../../components/form/Select";
import { getCategoryList } from "../../../services/machineService";
import { companyNameCheck, getCompanyType, getIndustriesType, saveCompanyInfo } from "../../../services/companyService";
const AddCompany = ({ companyInfo, companyImg, refreshPage }) => {
  const navigate = useNavigate();
  // const { instance, accounts } = useMsal(); // Azure B2C - temporarily disabled
  const Logout = localStorage.getItem("getAzureUserData");
  const [previewImage, setPreviewImage] = useState(null); // Image for modal preview
  const [images, setImages] = useState([]);
  const [addMachineLoader, setAddMachineLoader] = useState(false);
  const [companyType, setCompanyType] = useState([]);
  const [industriesType, setIndustriesType] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [extraData, setExtraData] = useState({ fields: [] });
  const [extraDataSchema, setExtraDataSchema] = useState(null);
  const [extraLoading, setExtraLoading] = useState(null);

  const decodedToken = (() => {
    try { return JSON.parse(localStorage.getItem("client_info") || "null"); } catch { return null; }
  })();
  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData"))
    : null;
  const inputRef = useRef(null);
  const inputRef2 = useRef(null);
  const formik = useFormik({
    initialValues: {
      companyName: "",
      phoneNumber: "",
      industry: "",
      companyType: "",
      address1: "",
      address2: "",
      city: "",
      province: "",
      country: "",
      companyTypeId: "",
      industryId: "",
    },
    validationSchema: Yup.object({
      companyName: Yup.string().required("Company Name is required"),
      address1: Yup.string().required("Address 1 is required"),
      city: Yup.string(),
      province: Yup.string(),
      country: Yup.string(),
      phoneNumber: Yup.string().required("Office Phone is required"),
    }),
    onSubmit: (values) => {
      if (Logout) {
        handleCheckCompanyNumber(values);
      } else {
        console.log("values", values);
      }
    },
  });

  useEffect(() => {
    if (!companyInfo) return;
    formik.setValues({
      ...formik.values,
      companyName: companyInfo.CompanyName || "",
      // Bug fix: API may return Phone or PhoneNumber depending on endpoint
      phoneNumber: companyInfo.PhoneNumber || companyInfo.Phone || "",
      industry: companyInfo.IndustryName || "",
      // Bug fix: API saves CompanyTypeIds as array, fallback to first element
      companyTypeId: companyInfo.CompanyTypeId || companyInfo.CompanyTypeIds?.[0] || "",
      industryId: companyInfo.IndustryId || "",
      address1: companyInfo.Address1 || "",
      address2: companyInfo.Address2 || "",
      city: companyInfo.City || "",
      // Bug fix: both province and state used, map correctly
      province: companyInfo.Province || companyInfo.State || "",
      country: companyInfo.Country || "",
    });
  }, [companyInfo]);

  useEffect(() => {
    if (companyImg?.length > 0) setImages(companyImg);
  }, [companyImg]);

  useEffect(() => {
    handleGetCompanyType();
    handleGetIndustriesType();
    GetExtraData();
    GetExtraDataSchema();
  }, []);

  const handleCheckCompanyNumber = (values) => {
    setAddMachineLoader(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    // Bug fix: trim company name to avoid extra spaces causing false duplicate errors
    const payload = `?companyName=${values?.companyName?.trim()}&companyId=${azureUserInfo?.CompanyId}`;
    companyNameCheck(payload, header)
      .then((res) => {
        SaveCompanyInfo(values);
      })
      .catch((err) => {
        toast.error(err?.data?.message || "Something went wrong.");
        setAddMachineLoader(false);
      });
  };


  const SaveCompanyInfo = async (values) => {
    setAddMachineLoader(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const getNewImages = images.filter((item) => item.New);

    const uploadPromises = getNewImages.map(async (item, index) => {
      const url = `pictureId=${azureUserInfo?.CompanyId}&directoryName=PavingMarket`;
      const payload = new FormData();
      payload.append("file", item.file);

      try {
        const uploadResponse = await uploadBulkImg(payload, header, url);
        let imgPayload = {
          Context: "Company",
          ContextId: azureUserInfo?.CompanyId,
          url: uploadResponse.data.url,
          PictureUuid: uploadResponse.data.pictureUuid,
          PictureContentType: uploadResponse.data.pictureContentType,
          FileSizeInBytes: uploadResponse.data.file.Length,
          FileName: uploadResponse.data.file.FileName.substring(0, uploadResponse.data.file.FileName.lastIndexOf(".")),
          FileFullName: uploadResponse.data.file.FileName,
        };
        const saveResponse = await savePicture(imgPayload, header);
      } catch (uploadErr) {
        console.error("Error uploading image:", uploadErr);
        toast.error(uploadErr?.data || "Image upload failed!");
        throw uploadErr; // Propagate error for outer handling
      }
    });
    try {
      await Promise.all(uploadPromises);
    } catch (e) {
      setAddMachineLoader(false);
      return;
    }

    let payload = {
      ...companyInfo,
      CompanyId: Number(azureUserInfo?.CompanyId),
      CompanyName: values?.companyName,
      PhoneNumber: values?.phoneNumber,
      CompanyTypeId: Number(values?.companyTypeId),
      CompanyTypeIds: [Number(values?.companyTypeId)],
      IndustryId: values?.industryId ? Number(values.industryId) : null,
      Address1: values?.address1,
      Address2: values?.address2,
      City: values?.city,
      Country: values?.country,
      Province: values?.province,
      RankingId: "5",
    };
    delete payload.phoneNumber;
    delete payload.companyTypeId;
    delete payload.industryId;
    delete payload.rankingId;
    delete payload.State;
    delete payload.IndustryName;
    delete payload.CompanyTypeNames;
    delete payload.CompanyTypeName;
    saveCompanyInfo(payload, header)
      .then((res) => {
        setIsEdit(false);
        toast.success("Company Edit Successfully");
        refreshPage();
        handleSaveExtraJSON();
        setAddMachineLoader(false);
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data);
      });
  };

  const handleSaveExtraJSON = (values, data) => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    let payload = {
      pkFieldValue: Number(azureUserInfo?.CompanyId),
      data: extraData,
      schema: extraDataSchema?.Schema ? JSON.parse(extraDataSchema.Schema) : null,
    };
    saveExtra(payload, header)
      .then((res) => {
        GetExtraData();
        GetExtraDataSchema();
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data);
      });
  };

  const handleGetCompanyType = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getCompanyType(header)
      .then((res) => {
        setCompanyType(res.data);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun();
        }
      });
  };

  const handleGetIndustriesType = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getIndustriesType(header)
      .then((res) => {
        setIndustriesType(res.data);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun();
        }
      });
  };

  // Handle file selection
  const handleFiles = (files) => {
    const newImages = Array.from(files).map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      New: true,
    }));
    setImages((prev) => [...prev, ...newImages]);
    formik.setFieldValue("images", [...images, ...newImages]);
    // Clear the input field value
    if (inputRef && inputRef.current) {
      inputRef.current.value = "";
    }
    if (inputRef2 && inputRef2.current) {
      inputRef2.current.value = "";
    }
  };
  // Handle drag-and-drop
  const handleDrop = (event) => {
    event.preventDefault();
    handleFiles(event.dataTransfer.files);
  };

  // Remove image
  const removeImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);

    // Update Formik's value
    formik.setFieldValue("images", updatedImages);
  };

  // Open preview modal
  const openPreview = (image) => {
    setPreviewImage(image);
  };

  // Close preview modal
  const closePreview = () => {
    setPreviewImage(null);
  };

  const handlePlaceSelect = (place, formik) => {
    const addressComponents = place?.address_components || [];

    const getComponent = (types) => {
      const component = addressComponents.find((comp) => comp.types.some((type) => types.includes(type)));

      return component ? component.long_name : "";
    };
    formik.setFieldValue(
      "location",
      `${place?.formatted_address} ${getComponent(["sublocality", "neighborhood"])} ${getComponent([
        "locality",
        "administrative_area_level_2",
      ])} ${getComponent(["administrative_area_level_1"])} ${getComponent(["country"])}` || formik.values.address1
    );

    formik.setFieldValue("address1", place?.formatted_address || formik.values.address1);
    formik.setFieldValue("address2", getComponent(["sublocality", "neighborhood"]) || "");
    formik.setFieldValue("city", getComponent(["locality", "administrative_area_level_2"]));
    // Bug fix: formik key is 'province', not 'state'
    formik.setFieldValue("province", getComponent(["administrative_area_level_1"]));
    formik.setFieldValue("country", getComponent(["country"]));
    formik.setFieldValue("postalCode", getComponent(["postal_code"]));
    formik.setFieldValue("lat", place?.geometry?.location?.lat());
    formik.setFieldValue("lng", place?.geometry?.location?.lng());
  };

  const GetExtraDataSchema = async () => {
    setExtraLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    let payload = `TableName=Company`;
    await getExtraDataSchema(payload, header)
      .then((res) => {
        setExtraDataSchema(res?.data?.[0] || null);
        setExtraLoading(false);
      })
      .catch((err) => {
        setExtraLoading(false);
      });
  };

  const GetExtraData = async () => {
    setExtraLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    let payload = `TableName=Company&PkFieldName=CompanyId&PkValue=${Number(azureUserInfo?.CompanyId)}`;
    await getExtraData(payload, header, undefined, undefined)
      .then((res) => {
        const data = res?.data;
        const normalized = data && typeof data === "object"
          ? { ...data, fields: Array.isArray(data.fields) ? data.fields : [] }
          : { fields: [] };
        setExtraData(normalized);
        setExtraLoading(false);
      })
      .catch(() => {
        setExtraData({ fields: [] });
        setExtraLoading(false);
      });
  };

  return (
    <>
      <PageWrapper name="Company Info">
        {/* <Subheader>
          <SubheaderLeft>
            <h1 className="my-4 font-bold">My Company Details</h1>
          </SubheaderLeft>
          <SubheaderRight>
            <Button
              variant="solid"
              onClick={() => {
                isEdit ? formik.submitForm() : setIsEdit(!isEdit);
              }}
            >
              {isEdit ? "Save" : "Edit"}
            </Button>
          </SubheaderRight>
        </Subheader> */}

        <Container>
          {isLoading || addMachineLoader ? (
            <div className="absolute w-[100%] h-[100dvh] bg-[#00000066] flex justify-center items-center z-50 top-0 right-0">
              <span className="loader"></span>
            </div>
          ) : null}
          <Card>
            <CardBody>
              {/* <Subheader> */}
              <div className="flex mb-[20px] items-center">
                <SubheaderLeft>
                  <h1 className="my-4 font-bold">My Company Details</h1>
                </SubheaderLeft>
                <SubheaderRight>
                  <Button
                    variant="solid"
                    onClick={() => {
                      isEdit ? formik.submitForm() : setIsEdit(!isEdit);
                    }}
                    className="!bg-[#FEBA06] border-none !text-black px-[20px] py-[12px] rounded-xl font-medium"
                  >
                    {isEdit && (
                      <div className="mr-3">
                        <Icon icon={"EditQIcon"} className={classNames("w-6 dark:text-white text-black")} />
                      </div>
                    )}
                    {isEdit ? "Save" : "Edit"}
                  </Button>
                </SubheaderRight>
              </div>
              {/* </Subheader> */}
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 lg:col-span-4">
                  <Card className="border h-full">
                    <CardBody>
                      <div className="flex flex-col gap-4">
                        {" "}
                        {images?.length <= 0 ? (
                          <div className="flex w-full items-center justify-center text-center h-[300px]">
                            <CardTitle>No Image Available</CardTitle>
                          </div>
                        ) : (
                          <div className="mt-[20px] grid-cols-1">
                            {images?.map((image, index) => (
                              <div
                                key={index}
                                className="relative group rounded-lg overflow-hidden my-[10px] text-center"
                              >
                                {/* Image */}
                                <img
                                  src={image.preview || image.url}
                                  alt={`Preview ${index}`}
                                  className="w-auto h-[100%] object-cover max-h-[300px] object-center mx-auto"
                                />

                                {/* Hover Preview */}
                                {/* <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                  <button
                                    className="text-white text-sm bg-gray-700 py-1 px-3 rounded hover:bg-gray-800"
                                    onClick={() => openPreview(image.preview || image.url)}
                                  >
                                    Preview
                                  </button>
                                </div> */}

                                {/* Remove Button */}
                                {/* {isEdit && (
                              <button
                                className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-1 text-xs hover:bg-red-700 w-[20px] h-[20px]"
                                onClick={() => removeImage(index)}
                              >
                                ✕
                              </button>
                            )} */}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      <div className="col-span-12 lg:col-span-6 mt-[20px]">
                        <Label htmlFor="id" className="flex items-center">
                          Upload new image
                          <div className="ml-2">
                            <Icon icon={"EditQIcon"} className={classNames("w-4 ml-2 dark:text-white text-black")} />
                          </div>
                        </Label>
                        <Input
                          type="file"
                          id="companyName"
                          name="companyName"
                          accept="image/*"
                          onChange={(e) => handleFiles(e.target.files)}
                          disabled={!isEdit}
                        />
                        {formik.touched.companyName && formik.errors.companyName ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.companyName}</p>
                        ) : null}
                      </div>
                    </CardBody>
                  </Card>
                </div>
                <div className="col-span-12 lg:col-span-8">
                  <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12">
                      <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 lg:col-span-6">
                          <div className="col-span-12 lg:col-span-6 mt-[20px]">
                            <Label htmlFor="id">Company Name</Label>
                            <Input
                              type="text"
                              id="companyName"
                              name="companyName"
                              onChange={formik.handleChange}
                              value={formik.values.companyName}
                              placeholder="Enter here"
                              disabled={!isEdit}
                            />
                            {formik.touched.companyName && formik.errors.companyName ? (
                              <p className="text-red-400 mt-1 text-[14px]">{formik.errors.companyName}</p>
                            ) : null}
                          </div>

                          <div className="col-span-12 lg:col-span-6 mt-[20px]">
                            <Label htmlFor="id">Office Phone</Label>
                            <Input
                              type="tel"
                              id="phoneNumber"
                              name="phoneNumber"
                              onChange={formik.handleChange}
                              value={formik.values.phoneNumber}
                              placeholder="Enter here"
                              disabled={!isEdit}
                            />
                            {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                              <p className="text-red-400 mt-1 text-[14px]">{formik.errors.phoneNumber}</p>
                            ) : null}
                          </div>

                          <div className="col-span-12 lg:col-span-6 mt-[20px]">
                            <Label htmlFor="id">Company Type</Label>
                            {/* <Input
                            type="text"
                            id="companyType"
                            name="companyType"
                            onChange={formik.handleChange}
                            value={formik.values.companyType}
                            disabled
                          /> */}

                            <Select
                              name="companyTypeId"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.companyTypeId}
                              placeholder="Select Company Type"
                              disabled={!isEdit}
                            >
                              <option
                                value=""
                                disabled
                                className="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                              >
                                Select Company Type
                              </option>
                              {companyType.map((item) => {
                                return (
                                  <option
                                    class="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                                    value={item.CompanyTypeId}
                                  >
                                    {item.CompanyTypeName}
                                  </option>
                                );
                              })}
                            </Select>
                            {formik.touched.companyType && formik.errors.companyType ? (
                              <p className="text-red-400 mt-1 text-[14px]">{formik.errors.companyType}</p>
                            ) : null}
                          </div>

                          <div className="col-span-12 lg:col-span-6 mt-[20px]">
                            <Label htmlFor="id">Industry</Label>
                            {/* <Input
                            type="text"
                            id="industry"
                            name="industry"
                            onChange={formik.handleChange}
                            value={formik.values.industry}
                            disabled
                          /> */}

                            <Select
                              name="industryId"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.industryId}
                              placeholder="Select Company Type"
                              disabled={!isEdit}
                            >
                              <option
                                value=""
                                disabled
                                className="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                              >
                                Select Industry Type
                              </option>
                              {industriesType.map((item) => {
                                return (
                                  <option
                                    class="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                                    value={item.IndustryId}
                                  >
                                    {item.IndustryName}
                                  </option>
                                );
                              })}
                            </Select>
                            {formik.touched.industry && formik.errors.industry ? (
                              <p className="text-red-400 mt-1 text-[14px]">{formik.errors.industry}</p>
                            ) : null}
                          </div>

                          <div className="col-span-12 lg:col-span-4  mt-[20px]">
                            <Label htmlFor="id">Country</Label>
                            <Input
                              type="text"
                              id="country"
                              name="country"
                              onChange={formik.handleChange}
                              value={formik.values.country}
                              disabled={!isEdit}
                            />
                            {formik.touched.country && formik.errors.country ? (
                              <p className="text-red-400 mt-1 text-[14px]">{formik.errors.country}</p>
                            ) : null}
                          </div>
                        </div>

                        <div className="col-span-12 lg:col-span-6">
                          <div className="col-span-12 lg:col-span-6 mt-[20px]">
                            <Label htmlFor="id">Address 1</Label>

                            <GooglePlacesAutocomplete
                              apiKey={Google_map_Key}
                              onPlaceSelected={(place) => handlePlaceSelect(place, formik)}
                              onChange={(e) => {
                                formik.setValues({
                                  ...formik.values,
                                  address1: e.target.value,
                                });
                              }}
                              disabled={!isEdit}
                              options={{
                                types: ["address"],
                              }}
                              value={formik.values.address1}
                              className="disabled:!opacity-1 w-full appearance-none outline-0 text-black dark:text-white transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-none !border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                            />
                            {formik.touched.address1 && formik.errors.address1 ? (
                              <p className="text-red-400 mt-1 text-[14px]">{formik.errors.address1}</p>
                            ) : null}
                          </div>

                          <div className="col-span-12 lg:col-span-6 mt-[20px]">
                            <Label htmlFor="id">Address 2</Label>
                            <Input
                              type="text"
                              id="address2"
                              name="address2"
                              onChange={formik.handleChange}
                              value={formik.values.address2}
                              disabled={!isEdit}
                            />
                            {formik.touched.address2 && formik.errors.address2 ? (
                              <p className="text-red-400 mt-1 text-[14px]">{formik.errors.address2}</p>
                            ) : null}
                          </div>

                          <div className="col-span-12 lg:col-span-4 mt-[20px]">
                            <Label htmlFor="id">City</Label>
                            <Input
                              type="text"
                              id="city"
                              name="city"
                              onChange={formik.handleChange}
                              value={formik.values.city}
                              disabled={!isEdit}
                            />
                            {formik.touched.city && formik.errors.city ? (
                              <p className="text-red-400 mt-1 text-[14px]">{formik.errors.city}</p>
                            ) : null}
                          </div>

                          <div className="col-span-12 lg:col-span-4 mt-[20px]">
                            <Label htmlFor="id">State</Label>
                            <Input
                              type="text"
                              id="province"
                              name="province"
                              onChange={formik.handleChange}
                              value={formik.values.province}
                              disabled={!isEdit}
                            />
                            {formik.touched.province && formik.errors.province ? (
                              <p className="text-red-400 mt-1 text-[14px]">{formik.errors.province}</p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* {isEdit && (
                      <div className="col-span-12">
                        <Card>
                          <CardHeader>
                            <CardHeaderChild>
                              <CardTitle>Image</CardTitle>
                            </CardHeaderChild>
                          </CardHeader>
                          <CardBody>
                            <div
                              className={classNames(
                                "mt-2",
                                "flex justify-center",
                                "rounded-lg",
                                "border border-dashed border-zinc-500/25",
                                "px-6 py-10",
                                "dark:border-zinc-500/50"
                              )}
                              onDragOver={(e) => e.preventDefault()}
                              onDrop={handleDrop}
                              onClick={() => document.getElementById("fileInput").click()}
                            >
                              <div className="text-center">
                                <Icon
                                  icon="HeroPhoto"
                                  className="mx-auto h-12 w-12"
                                  color={themeConfig.themeColor}
                                  colorIntensity={themeConfig.themeColorShade}
                                />
                                <div className="mt-4 flex text-sm leading-6 text-gray-500">
                                  <label
                                    htmlFor="file-upload"
                                    className={classNames(
                                      "relative",
                                      "cursor-pointer",
                                      "rounded-md",
                                      "font-semibold",
                                      "text-blue-500",
                                      "focus-within:outline-none",
                                      "focus-within:ring-2 focus-within:ring-blue-600 focus-within:ring-offset-2 focus-within:ring-offset-transparent",
                                      "hover:text-blue-600",
                                      themeConfig.transition
                                    )}
                                  >
                                    <span>Upload a file</span>
                                    <input id="file-upload" name="file-upload" type="file" className="sr-only" />
                                  </label>
                                  <span className="pl-1">or drag and drop</span>
                                </div>
                                <p className="text-xs leading-5 text-gray-500">PNG, JPG</p>
                              </div>
                              <input
                                type="file"
                                id="fileInput"
                                className="hidden"
                                multiple
                                accept="image/*"
                                ref={inputRef}
                                onChange={(e) => handleFiles(e.target.files)}
                              />
                            </div>
                            {formik.touched.images && formik.errors.images ? (
                              <p className="text-red-400 mt-1 text-[14px]">{formik.errors.images}</p>
                            ) : null}
                          </CardBody>
                        </Card>
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          {previewImage && (
            <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
              <div className="relative bg-zinc-100 dark:bg-zinc-800 p-4 rounded-lg max-w-[90%] max-h-[90%]">
                <button
                  className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-2 hover:bg-red-700  w-[30px] h-[30px] cursor-pointer flex items-center justify-center"
                  onClick={closePreview}
                >
                  ✕
                </button>
                <img src={previewImage} alt="Preview" className="max-w-full max-h-[80vh] object-contain" />
              </div>
            </div>
          )}

          {extraLoading ? (
            <div className="col-span-12  mt-6">
              <div role="status" className="animate-pulse">
                <div className="h-[200px] bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            extraDataSchema?.Schema && (
              <div className="col-span-12 mt-6">
                <Card>
                  <CardHeader>
                    <CardHeaderChild>
                      <CardTitle>Advertising Settings</CardTitle>
                    </CardHeaderChild>
                  </CardHeader>
                  <CardBody>
                    <div className="grid grid-cols-12 gap-4">
                      {JSON.parse(extraDataSchema?.Schema || "")
                        ?.fields?.sort((a, b) => Number(a.order) - Number(b.order))
                        .map((item, index) => {
                          console.log("item?.controlType", item?.controlType);
                          return item?.controlType === "Input" ? (
                            <div className="lg:col-span-3 col-span-6 mt-[10px]">
                              <Label htmlFor="id">{item?.label}</Label>
                              <Input
                                type="text"
                                id={item?.name}
                                name={item?.name}
                                value={
                                  extraData?.fields?.find((extraDataItem) => extraDataItem?.name === item?.name)?.value
                                }
                                onChange={(event) => {
                                  const { value } = event.target;
                                  setExtraData((prevData) => {
                                    const base = prevData && typeof prevData === "object" ? prevData : {};
                                    const fields = Array.isArray(base.fields) ? base.fields : [];
                                    const exists = fields.some((extraDataItem) => extraDataItem?.name === item.name);
                                    const updatedFields = exists
                                      ? fields.map((extraDataItem) =>
                                          extraDataItem?.name === item.name ? { ...extraDataItem, value } : extraDataItem
                                        )
                                      : [...fields, { name: item.name, value }];
                                    return { ...base, fields: updatedFields };
                                  });
                                }}
                                placeholder="Enter here"
                                disabled={!isEdit}
                              />
                            </div>
                          ) : item?.controlType === "InputNumber" ? (
                            <div className="lg:col-span-3 col-span-6 mt-[10px]">
                              <Label htmlFor="id">{item?.label}</Label>
                              <Input
                                type="number"
                                id={item?.name}
                                name={item?.name}
                                onChange={(event) => {
                                  const { value } = event.target;
                                  setExtraData((prevData) => {
                                    const base = prevData && typeof prevData === "object" ? prevData : {};
                                    const fields = Array.isArray(base.fields) ? base.fields : [];
                                    const exists = fields.some((extraDataItem) => extraDataItem?.name === item.name);
                                    const updatedFields = exists
                                      ? fields.map((extraDataItem) =>
                                          extraDataItem?.name === item.name ? { ...extraDataItem, value } : extraDataItem
                                        )
                                      : [...fields, { name: item.name, value }];
                                    return { ...base, fields: updatedFields };
                                  });
                                }}
                                value={
                                  extraData?.fields?.find((extraDataItem) => extraDataItem?.name === item?.name)?.value
                                }
                                placeholder="Enter here"
                                disabled={!isEdit}
                              />
                            </div>
                          ) : item?.controlType === "DatePicker" ? (
                            <div className="lg:col-span-3 col-span-6 mt-[10px]">
                              <Label htmlFor="id">{item?.label}</Label>
                              <Input
                                type="date"
                                id={item?.name}
                                name={item?.name}
                                onChange={(event) => {
                                  const { value } = event.target;
                                  setExtraData((prevData) => {
                                    const base = prevData && typeof prevData === "object" ? prevData : {};
                                    const fields = Array.isArray(base.fields) ? base.fields : [];
                                    const exists = fields.some((extraDataItem) => extraDataItem?.name === item.name);
                                    const updatedFields = exists
                                      ? fields.map((extraDataItem) =>
                                          extraDataItem?.name === item.name ? { ...extraDataItem, value } : extraDataItem
                                        )
                                      : [...fields, { name: item.name, value }];
                                    return { ...base, fields: updatedFields };
                                  });
                                }}
                                value={
                                  extraData?.fields?.find((extraDataItem) => extraDataItem?.name === item?.name)?.value
                                }
                                placeholder="Enter here"
                                disabled={!isEdit}
                              />
                            </div>
                          ) : item?.controlType === "InputCurrency" ? (
                            <div className="lg:col-span-3 col-span-6 mt-[10px]">
                              <Label htmlFor="id">{item?.label}</Label>
                              <div className="input-group flex items-center bg-zinc-100 dark:bg-zinc-800 rounded-lg">
                                <div className="input-group-prepend mr-2 ml-4">
                                  <span className="input-group-text">$</span>
                                </div>
                                <Input
                                  type="number"
                                  id={item?.name}
                                  name={item?.name}
                                  onChange={(event) => {
                                    const { value } = event.target;
                                    setExtraData((prevData) => {
                                      const base = prevData && typeof prevData === "object" ? prevData : {};
                                      const fields = Array.isArray(base.fields) ? base.fields : [];
                                      const exists = fields.some((extraDataItem) => extraDataItem?.name === item.name);
                                      const updatedFields = exists
                                        ? fields.map((extraDataItem) =>
                                            extraDataItem?.name === item.name ? { ...extraDataItem, value } : extraDataItem
                                          )
                                        : [...fields, { name: item.name, value }];
                                      return { ...base, fields: updatedFields };
                                    });
                                  }}
                                  value={
                                    extraData?.fields?.find((extraDataItem) => extraDataItem?.name === item?.name)
                                      ?.value
                                  }
                                  placeholder="Enter here"
                                  disabled={!isEdit}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="lg:col-span-3 col-span-6 mt-[10px]">
                              <Label htmlFor="id">{item?.label}</Label>
                              <Input
                                type="text"
                                id={item?.name}
                                name={item?.name}
                                onChange={(event) => {
                                  const { value } = event.target;
                                  setExtraData((prevData) => {
                                    const base = prevData && typeof prevData === "object" ? prevData : {};
                                    const fields = Array.isArray(base.fields) ? base.fields : [];
                                    const exists = fields.some((extraDataItem) => extraDataItem?.name === item.name);
                                    const updatedFields = exists
                                      ? fields.map((extraDataItem) =>
                                          extraDataItem?.name === item.name ? { ...extraDataItem, value } : extraDataItem
                                        )
                                      : [...fields, { name: item.name, value }];
                                    return { ...base, fields: updatedFields };
                                  });
                                }}
                                value={
                                  extraData?.fields?.find((extraDataItem) => extraDataItem?.name === item?.name)?.value
                                }
                                placeholder="Enter here"
                                disabled={!isEdit}
                              />
                            </div>
                          );
                        })}
                    </div>
                  </CardBody>
                </Card>
              </div>
            )
          )}
        </Container>
      </PageWrapper>
    </>
  );
};
export default AddCompany;
